import { useEffect } from 'react'
import { useBlocker } from 'react-router-dom'

export type UseUnsavedChangesGuardResult = {
  isBlocked: boolean
  onConfirmLeave: () => void
  onCancelLeave: () => void
}

export function useUnsavedChangesGuard(
  hasChanges: boolean,
): UseUnsavedChangesGuardResult {
  const blocker = useBlocker(hasChanges)

  useEffect(() => {
    if (!hasChanges) return

    const handler = (event: BeforeUnloadEvent) => {
      event.preventDefault()
      event.returnValue = ''
    }

    window.addEventListener('beforeunload', handler)
    return () => {
      window.removeEventListener('beforeunload', handler)
    }
  }, [hasChanges])

  return {
    isBlocked: blocker.state === 'blocked',
    onConfirmLeave: () => blocker.proceed?.(),
    onCancelLeave: () => blocker.reset?.(),
  }
}
